module.exports = __webpack_public_path__ + "img/tips.5aa2b294.png";